<!--
     <FieldFile>
-->

<template>
  <div v-if="short && showIcon">
    <v-icon
      small
      :color="icon_color"
      class="fieldfile-icon"
      @click.stop="downloadFile"
      >
        {{ type_icon }}
      </v-icon>    
  </div>
  <span  v-else>
    <field-string
      :field="field"
      :short="true"
      :is_mobile="is_mobile"
      :max_text_size="50"
      css_class=""
    >
    </field-string>
    <v-icon
      v-if="showIcon"
      small
      :color="icon_color"
      class="fieldfile-icon"
      @click.stop="downloadFile"
    >
      {{ type_icon }}
    </v-icon>
  </span>
</template>

<style>
  .fieldfile-icon:after{
    height: unset !important;
  }
</style>
  
<script>
import FieldString from './FieldString.vue';
import FileIcons from '@/utils/fileicons'
export default {
  name: 'FielFile',

  props: {
    field: { required: true },
    short: { type: Boolean, default: false },
    is_mobile: { type: Boolean, default: false },
  },
  components: {
    FieldString
  },

  data(){
    return{
      files: FileIcons,
    }
  },
  
  computed: {
    representation() {
      return '' + this.field;
    },
    showIcon() {
    return !!this.field.value
    },
    type_icon() {
    const mimetype = this.field.mimetype()
    return mimetype ? this.files[mimetype].icon : 'mdi-download';
    },
    icon_color() {
    const mimetype = this.field.mimetype();
    return mimetype ? this.files[mimetype].color : '';
    }
  },
  methods:{
    downloadFile(){
      this.$emit('download-evidence', this.field)
    }
  },
};
</script>